export const ingredientsInitial = [
    {
      id: 'chicken-marinade',
      name: 'Chicken with marinade',
      items: [
        {
          name: 'Chicken thighs (skinless)',
          number: '1.25',
          unit: 'lbs',
          numberMetric: '567',
          unitMetric: 'g'
        },
        {
          name: 'Milk',
          number: '0.5',
          unit: 'cup',
          numberMetric: '125',
          unitMetric: 'g'
        },
        {
          name: 'Gochugaru',
          number: '1',
          unit: 'Tbsp',
          note: 'Red pepper powder'
        },
        {
          name: 'Gochujang',
          number: '3',
          unit: 'Tbsp',
          note: 'Red pepper paste'
        },
        {
          name: 'Honey',
          number: '1',
          unit: 'Tbsp'
        },
        {
          name: 'Soy sauce',
          number: '2',
          unit: 'Tbsp'
        },
        {
          name: 'Sugar',
          number: '1',
          unit: 'Tbsp'
        },
        {
          name: 'Garlic',
          number: '8',
          unit: 'cloves',
          preparation: 'minced'
        },
        {
          name: 'White onion',
          number: '0.25',
          preparation: 'minced'
        },
        {
          name: 'Ginger',
          number: '1',
          unit: 'Tbsp',
          preparation: 'minced'
        },
        {
          name: 'Black pepper',
          number: '1',
          unit: 'tsp'
        },
        {
          name: 'Curry powder',
          number: '1',
          unit: 'tsp'
        }
      ]
    },
    {
      id: 'stir-fry',
      name: 'Stir Fry',
      items: [
        {
          name: 'Cabbage',
          number: '1',
          unit: 'cup',
          numberMetric: '70–100',
          unitMetric: 'g',
          preparation: 'sliced'
        },
        {
          name: 'White onion',
          number: '0.25',
          preparation: 'sliced'
        },
        {
          name: 'Sweet potato',
          number: '0.5',
          preparation: 'peeled & sliced into sticks'
        },
        {
          name: 'Green onion',
          number: '1',
          unit: 'bunch',
          preparation: 'sliced'
        },
        {
          name: 'Perilla leaves',
          number: '4',
          preparation: 'sliced'
        },
        {
          name: 'Rice cakes',
          number: '0.5',
          unit: 'cup',
          numberMetric: '30–40',
          unitMetric: 'g'
        },
        {
          name: 'Oil',
          number: '1',
          unit: 'Tbsp'
        },
        {
          name: 'Water',
          number: '0.25',
          unit: 'cup',
          numberMetric: '60',
          unitMetric: 'g'
        },
        {
          name: 'Mozzarella (shredded)',
          number: '0.5',
          unit: 'cup',
          numberMetric: '60',
          unitMetric: 'g'
        },
        {
          name: 'Parsley or Basil (dried)',
          note: 'optional garnish'
        }
      ]
    }
];

export const ingredients = ingredientsInitial.map((ingredient) => ({
    ...ingredient,
    items: ingredient.items.map((item) => ({
        ...item,
        checked: false,
    })),
}));